import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';



@Component({
  templateUrl: './main-menu-page.html',
  styleUrls: ['./main-menu-page.scss'],
})

export class MainMenuPageComponent {


  constructor(
    private authService:AuthService,
    private router:Router,
  ) {
  }


  ngOnInit() {


  }



  navTo(dest) {
    this.router.navigate([dest]);
  }


  logout() {
    this.authService.logout(true);
  }


}



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/main-menu-page/main-menu-page.ts